angular.module('bribac.components.inputFile', [])

  .component('inputFile', {
    templateUrl: 'input-file-component.html',
    transclude: true,
    controller: 'InputFileComponentCtrl',
    bindings: {
      buttonCaption: '<',
      componentAccept: '<',
      componentId: '<',
      componentModel: '=',
      componentName: '<',
      textPlaceholder: '<',
      componentOnAfterValidate:"<"
    }
  })

  .controller('InputFileComponentCtrl', function( $timeout ) {
    var $ctrl = this

    $ctrl.clickSelectFile = function () {
      $timeout( function () {
        document.getElementById( $ctrl.componentId ).click()
      } );
    }
  })